import service from "@/utils/request";
// 曲谱列表
export const getRelateSheetListApi = (params: {
  page: number;
  page_size: number;
  name: string;
  instrument_ids: number[];
  create_start_time: number;
  create_end_time: number;
  status: number;
  teach_status: number;
}) => {
  return service({
    url: "/api/v1/music/list",
    method: "get",
    params,
  });
};
// 乐器列表
export const getSheetInstrumentListApi = () => {
  return service({
    url: "/api/v1/music/instrument/list",
    method: "get",
  });
};
// 歌手列表
export const getSheetSingerListApi = () => {
  return service({
    url: "/api/v1/music/singer/list",
    method: "get",
  });
};
// 曲谱预览
export const previewSheetApi = (params: { music_id: number }) => {
  return service({
    url: "/api/v1/music/preview",
    method: "get",
    params,
  });
};
